export interface IServerResponse<T = any> {
  data?: T;
  error: any;
  message: string;
  statusCode: number;
}

export class ServerResponse<T = any> {
  data?: T;
  error: any;
  message: string;
  statusCode: number;

  constructor(data: IServerResponse<T>) {
    this.data = data.data;
    this.error = data.error;
    this.message = data.message;
    this.statusCode = data.statusCode;
  }

  get ok(): boolean {
    return this.statusCode >= 200 && this.statusCode < 300;
  }
}
